 
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import isEqual from 'lodash-es/isEqual';
import { catchError, Observable } from 'rxjs';
import { EnvironmentConfig } from '../models/config.model';
import { ApiContract } from '../models/framework.model';
import { NotificationModel } from '../models/notification.model';
import { ConfigService } from './config.service';
import { ErrorService } from './error.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private http = inject(HttpClient);
  private errorService = inject(ErrorService);

  private config: EnvironmentConfig;
  private BASE_API_URL?: string;
  private criteria: NotificationModel[] = [];

  constructor() {
    this.config = inject(ConfigService);
    this.BASE_API_URL = this.config.sharedApiUrl;
  }

  fitsAutoDismissCriteria(newNotification: NotificationModel): boolean {
    const dismissalCheck = {
      entityKey: newNotification.entityKey,
      entityType: newNotification?.entityType,
      entitySubType: newNotification?.entitySubType
    } as NotificationModel;
    return this.criteria.some((x) => isEqual(x, dismissalCheck));
  }

  setAutoDismissCriteria(newCriteria: NotificationModel) {
    this.criteria.push(newCriteria);
  }

  removeAutoDismissCriteria(oldCriteria: NotificationModel) {
    const index = this.criteria.indexOf(oldCriteria);
    if (index >= 0) {
      this.criteria.splice(index, 1);
    }
  }

  getNotifications(): Observable<ApiContract<NotificationModel[]>> {
    const url = `${this.BASE_API_URL}/notification`;
    return this.http.get<ApiContract<NotificationModel[]>>(url).pipe(catchError(this.errorService.handleError('getNotifications')));
  }

  getNotificationCount(): Observable<ApiContract<number>> {
    const url = `${this.BASE_API_URL}/notification/count`;
    return this.http.get<ApiContract<number>>(url).pipe(catchError(this.errorService.handleError('getNotificationCount')));
  }

  dismissNotificationById(notificationId: number): Observable<ApiContract<NotificationModel>> {
    const url = `${this.BASE_API_URL}/notification/${notificationId}`;
    return this.http.delete<ApiContract<NotificationModel>>(url).pipe(catchError(this.errorService.handleError('dismissNotificationById')));
  }

  dismissNotificationByEntity(notification: NotificationModel): Observable<ApiContract<NotificationModel>> {
    const url = `${this.BASE_API_URL}/notification/${notification.entityKey}/${notification.entityType}/${notification.entitySubType}`;
    return this.http.delete<ApiContract<NotificationModel>>(url).pipe(catchError(this.errorService.handleError('dismissNotificationByEntity')));
  }
}
